import * as React from 'react';
import toast from 'cogo-toast';
import { Page, Grid, Card } from 'tabler-react';
import store from '../../shared/store';
import PageComponent from '../PageComponent';
import './support.scss';
import i18n from '../../shared/i18n';

class TicketIndex extends PageComponent {
  state = {};

  openIntercom = () => {
    if (store.user.userType !== 'GAME') {
      toast.warn(i18n.t('dash-support-onlinealert'));
      return;
    }
    if (window.Intercom) {
      window.Intercom && window.Intercom('showNewMessage')
      document.querySelector('.intercom-launcher-frame').style.display = 'block';
    }
  };

  openFeedback = () => {
    if (!['GAME', 'TURBO'].includes(store.user.userType)) {
      toast.warn(i18n.t('dash-support-feedbackalert'));
      return;
    }
    window.location.href = `/r/ticket`;
  };

  render() {
    return (
      <Page.Content className="ticket">
        <Grid.Row cards>

          <Grid.Col xs={12} md={4}>
            <Card className="item-ticket">

              <Card.Body>
                <div className="icons">
                  <i className="ri-question-line"></i>
                </div>
                <div className="title">{i18n.t('dash-support-common')}</div>
                <span>{i18n.t('dash-support-commontip')}</span>
                <a href="/support" target="_blank" className="btn-support free">{i18n.t('dash-support-commonbtn')}</a>
              </Card.Body>
            </Card>
          </Grid.Col>

          <Grid.Col xs={12} md={4}>
            <Card className="item-ticket">

              <Card.Body>
                <div className="icons">
                  <i className="ri-draft-line"></i>
                </div>
                <div className="title">{i18n.t('dash-support-feedback')}</div>
                <span>{i18n.t('dash-support-feedbacktip')}</span>
                <div className="tag">{i18n.t('dash-support-feedbacktag')}</div>
                <div onClick={this.openFeedback} className="btn-support vip">{i18n.t('dash-support-feedbackbtn')}</div>
              </Card.Body>
            </Card>
          </Grid.Col>

          <Grid.Col xs={12} md={4}>
            <Card className="item-ticket">
              <Card.Body>
                <div className="icons">
                  <i className="ri-chat-smile-2-line"></i>
                </div>
                <div className="title">{i18n.t('dash-support-online')}</div>
                <span>{i18n.t('dash-support-onlinetip')}</span>
                <div className="tag">{i18n.t('dash-support-onlinetag')}</div>
                <div className="btn-support svip" onClick={this.openIntercom}>{i18n.t('dash-support-onlinebtn')}</div>
              </Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>

      </Page.Content>
    );
  }
}

export default TicketIndex;
